// extracted by mini-css-extract-plugin
module.exports = {"root":"TravelGuidesBlock_root__HgUXY"};